import React from 'react';
import FigoLottie from '../../../common/FigoLottie';

import styles from './RoundedButton.module.css';

const ROUNDED_BUTTON_TYPE = {
  BLUE: 'blue',
  WHITE: 'white',
};

const RoundedButton = ({
  buttonType = ROUNDED_BUTTON_TYPE.BLUE,
  disabled = false,
  isSubmitType = false,
  label = '',
  loading = false,
  onClick = () => {},
}) => (
  <button
    className={buttonType === ROUNDED_BUTTON_TYPE.BLUE
      ? styles.roundedButtonBlue : styles.roundedButtonWhite}
    disabled={disabled}
    onClick={onClick}
    type={isSubmitType ? 'submit' : 'button'}
  >
    {loading ? <FigoLottie height={15} width={15} /> : label}
  </button>
);

export { RoundedButton, ROUNDED_BUTTON_TYPE };
